/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Story_Hint_TextInputs */

const vi_shop_group_story_hint_text = /** @type {(inputs: Shop_Group_Story_Hint_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được danh sách Câu chuyện. Nhập đường dẫn (slug) của mục Câu chuyện, vd chuyen-che-tom-non.`)
};

/**

* @param {Shop_Group_Story_Hint_TextInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_story_hint_text = /** @type {((inputs?: Shop_Group_Story_Hint_TextInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Story_Hint_TextInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_story_hint_text(inputs)
});